import { render, staticRenderFns } from "./ReportDecisions.vue?vue&type=template&id=7127e8de&"
import script from "./ReportDecisions.vue?vue&type=script&lang=js&"
export * from "./ReportDecisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports